<div
  class="munily-text-area-field"
  [class.munily-text-area-field--error]="showError()"
  [class.munily-text-area-field--disabled]="disabled"
  [class.munily-text-area-field--success]="showSuccessOutline()"
  [attr.aria-labelledby]="label ? labelId : null"
>
  <!-- <label *ngIf="label" [id]="labelId" class="munily-text-area-field__label">{{ label }}</label> -->

  <div class="munily-text-area-field__shell">
    <div
      class="munily-text-area-field__editor"
      [froalaEditor]="froalaOptions"
      [formControl]="formControlForFroala"
      (froalaInit)="onFroalaInit($event)"
    ></div>
  </div>

  <ng-container *ngIf="!showError() && (hint || hasCharacterCounter)">
    <div class="munily-text-area-field__sub">
      <p *ngIf="hint" class="munily-text-area-field__hint">{{ hint }}</p>
      <p *ngIf="hasCharacterCounter" class="munily-text-area-field__counter" aria-live="polite">
        {{ displayedCharacterCount }}<span *ngIf="maxCharacters != null"> / {{ maxCharacters }}</span>
      </p>
    </div>
  </ng-container>
  <p *ngIf="showError()" class="munily-text-area-field__error" role="alert">{{ resolvedErrorMessage }}</p>
</div>
